import React, {Component} from 'react'
import style from './IconCateg.less'
import {OPENING_TICKET_PURPOSE_REF_ICONS} from '../../reference/models'

class Icon extends Component {
    render() {
        const {iconId, exponent} = this.props
        return (
            <div>
                <svg className={style.iconCateg} width={60} height={60}>
                    <use href={`/external/categ.svg#${OPENING_TICKET_PURPOSE_REF_ICONS.find((i) => i === iconId) || 'questionmark'}`}/>
                </svg>
                {exponent && <span className={style.exponent}>
                    {exponent}
                </span>}
            </div>
        )
    }
}

export default Icon


// WEBPACK FOOTER //
// ./lib/core/components/IconCateg.js